import getTotalRemainingSeconds from './getTotalRemainingSeconds';

export default (endTime: number, date: Date): number => {
  return Math.floor(getTotalRemainingSeconds(endTime, date) / 60 / 60) % 24;
};
